import { render, staticRenderFns } from "./member-custom-tags-editor.vue?vue&type=template&id=274713e9&scoped=true"
import script from "./member-custom-tags-editor.vue?vue&type=script&lang=js"
export * from "./member-custom-tags-editor.vue?vue&type=script&lang=js"
import style0 from "./member-custom-tags-editor.vue?vue&type=style&index=0&id=274713e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274713e9",
  null
  
)

export default component.exports